export enum ESurfaceEau {
    Lisse = 1,
    FaiblementAgitee = 2,
    Agitee = 3,
    TresAgitee = 4,
}